import React, { useState } from "react";

export function ConfirmationSectionRow(props) {
  // const [isComing, setIsComing] = useState(null);

  const changeIsComing = (coming) => {
    // setIsComing(coming);
    props.changeIsComing(props.name, coming);
  };

  return (
    <div className="confirmation__section__row">
      <p>{props.name}</p>
      <button
        type="button"
        className={`is__coming ${
          props.isComing === true ? "is__coming__active" : ""
        }`}
        onClick={() => changeIsComing(true)}
      >
        Yes
      </button>
      <button
        type="button"
        className={`not__coming ${
          props.isComing === false ? "not__coming__active" : ""
        }`}
        onClick={() => changeIsComing(false)}
      >
        no
      </button>
    </div>
  );
}
